import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Instagram, Facebook, MessageCircle } from 'lucide-react';
export function Footer() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      tagline: 'Fine Art Tattoo | Miami, FL',
      rights: '© 2024 KRLY Gold Tattoo. Miami, FL. All rights reserved.'
    },
    es: {
      tagline: 'Tatuaje Fine Art | Miami, FL',
      rights: '© 2024 KRLY Gold Tattoo. Miami, FL. Todos los derechos reservados.'
    }
  };
  const t = content[language];
  return <footer className="relative border-t border-brand-gold/30 overflow-hidden" data-id="element-36">
      <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/fTqV2KPKRdTLDWmc4Laip1/kgt_logo.png')] bg-cover bg-center" data-id="element-37" />
      <div className="absolute inset-0 bg-brand-black/80" data-id="element-38" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12" data-id="element-39">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center text-center md:text-left" data-id="element-40">
          {/* Left */}
          <div data-id="element-41">
            <h3 className="font-serif text-brand-gold text-xl tracking-widest uppercase mb-2" data-id="element-42">
              KRLY GOLD TATTOO
            </h3>
            <p className="text-brand-white/60 font-sans text-xs tracking-widest uppercase" data-id="element-43">
              {t.tagline}
            </p>
          </div>

          {/* Center - Socials */}
          <div className="flex justify-center gap-6" data-id="element-44">
            <a href="https://instagram.com/krlygoldtattoo" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors" data-id="element-45">
              <Instagram className="w-6 h-6" data-id="element-46" />
            </a>
            <a href="https://www.facebook.com/share/1CqVNdK2Fb/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors" data-id="element-47">
              <Facebook className="w-6 h-6" data-id="element-48" />
            </a>
            <a href="https://wa.me/13057256699" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors" data-id="element-49">
              <MessageCircle className="w-6 h-6" data-id="element-50" />
            </a>
          </div>

          {/* Right */}
          <div className="md:text-right text-brand-white/40 font-sans text-xs tracking-wider" data-id="element-51">
            <p data-id="element-52">
              {'\xA9 2022 KRLY Gold Tattoo. Miami, FL. Todos los derechos reservados.'}
            </p>
          </div>
        </div>
      </div>
      <div className="h-px w-full bg-brand-gold/30" data-id="element-53" />
    </footer>;
}